/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sortingweight1Inputs */

const en__field_sortingweight1 = /** @type {(inputs: _Field_Sortingweight1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorting`)
};

const de__field_sortingweight1 = /** @type {(inputs: _Field_Sortingweight1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortierung`)
};

/**
* | output |
* | --- |
* | "Sorting" |
*
* @param {_Field_Sortingweight1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sortingweight1 = /** @type {((inputs?: _Field_Sortingweight1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sortingweight1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sortingweight1(inputs)
	return de__field_sortingweight1(inputs)
});
export { _field_sortingweight1 as "_field_sortingWeight" }